module.exports = __webpack_public_path__ + "static/media/rs.291d0fb6.svg";